import React from "react";
import { Parah } from "../ContentsStyles";

const PP_9 = () => {
  return (
    <>
      <Parah>
        We may amend or update this Privacy Policy from time to time. We will
        notify you of any material changes to this policy by a notice provided
        through the Platform or by other means. The “Last Updated” date at the
        top of this policy reflects the effective date of such policy changes.
      </Parah>
    </>
  );
};

export default PP_9;
